import { Alert, Box } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';

type LocationLike = Pick<Location, 'pathname' | 'search'>;

export function parsePublicDriveEmbed(location: LocationLike): { shareId: string; view: string } {
  const rawPath = location.pathname.replace(/^\/drive\/?/, '');
  const normalizedSearch = (location.search || '').replace(/&amp;/g, '&');
  const params = new URLSearchParams(normalizedSearch);
  for (const part of rawPath.split('&').slice(1)) {
    const [key, ...valueParts] = part.split('=');
    const value = valueParts.join('=');
    if (key && value && !params.has(key)) params.set(key, value);
  }
  return {
    shareId: params.get('share') || params.get('embed') || '',
    view: (params.get('view') || '').toLowerCase(),
  };
}

/**
 * Compatibility route for old /drive?share= links. It stays on the Box
 * origin and forwards presentation state into the canonical /embed route.
 */
export function PublicDriveEmbedPage() {
  const location = useLocation();
  const parsed = parsePublicDriveEmbed(location);
  if (!parsed.shareId) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
        <Alert severity="error">Missing embed share token</Alert>
      </Box>
    );
  }
  const params = new URLSearchParams();
  if (parsed.view) params.set('view', parsed.view);
  const suffix = params.size ? `?${params}` : '';
  return <Navigate to={`/embed/${encodeURIComponent(parsed.shareId)}${suffix}`} replace />;
}
